export const peersTenettest = {   
    "peers":"3c47beafdf96bcb80361b72f15ebd5e72cf6afd0@167.172.36.160:26656,481a597e65a722ab88304d9ce17b7496c3b13d03@51.75.164.249:26656,e8da5f6f1c3d70e08f4ed7898781acd44b2b36cf@38.146.3.211:22456"
}